import ModalUserCertificationsModule from './containers/modalUserCertificationsModule'

export {default as ModalUserCertificationsModuleLayout} from './components/modalUserCertificationsModuleLayout'

export default ModalUserCertificationsModule
